import React, {useState, useEffect} from 'react';
import {addCommas, formatNumber} from '../../utils/common-functions';



function Level(props) {
  const [stats, setStats] = useState({deltaconfirmed: 0, 
                                      deltadeaths: 0 , 
                                      deltarecovered: 0,
                                      deltaactive: 0,
                                      active: 0,
                                      cases:0,
                                      recovered: 0,
                                      deaths: 0
                                       });
  //const [oldData, setOldData] = useState(props.old)
  const { data,yesterdayData}  = props.data;


  useEffect(() => {
    const deltaconfirmed = data.cases - yesterdayData.cases;

    const  deltadeaths =  data.deaths - yesterdayData.deaths;
    const deltarecovered = data.recovered - yesterdayData.recovered;
    const deltaactive = data.active - yesterdayData.active;
  

    setStats({
      active: +data.active,
      confirmed: +data.cases,
      recovered: +data.recovered,
      deaths: +data.deaths,
      deltaconfirmed: deltaconfirmed,
      deltadeaths: deltadeaths,
      deltarecovered: deltarecovered,
      deltaactive: deltaactive
    });
  }, []);

  useEffect(() => {
    const deltaconfirmed = (+data.cases) - (+yesterdayData.cases);
    const  deltadeaths = (+data.deaths) - (+yesterdayData.deaths);
    const deltarecovered = (+data.recovered) - (+yesterdayData.recovered);
    const deltaactive = (+data.active) - (+yesterdayData.active)

    setStats({
      active: +data.active,
      confirmed: +data.cases,
      recovered: +data.recovered,
      deaths: +data.deaths,
      deltaconfirmed: +deltaconfirmed,
      deltadeaths: +deltadeaths,
      deltarecovered: +deltarecovered,
      deltaactive: +deltaactive
    });
  }, [props.data]);

  return (
    <div className="Level">
      <div
        className="level-item is-cherry fadeInUp"
        style={{animationDelay: '1s'}}
      >
        <h5>Confirmed</h5>
        <h4>
          [
          { stats.deltaconfirmed == 0 ? "" 
            : stats.deltaconfirmed >= 0
            ? '+' + stats.deltaconfirmed
            : '' + stats.deltaconfirmed }
          ]
        </h4>
        <h1>{stats.confirmed == 0 ? "N/A" :addCommas(stats.confirmed)} </h1>
      </div>

      <div
        className="level-item is-blue fadeInUp"
        style={{animationDelay: '1.1s'}}
      >
        <h5 className="heading">Active</h5>
         
         <h4>
         [
          {stats.deltaactive == 0 ? "" 
            : stats.deltaactive >= 0
            ? '+' + stats.deltaactive
            : '' + stats.deltaactive}
          ]
          </h4> 
        <h1 className="title has-text-info">{ stats.active == 0 ? "N/A" : addCommas(stats.active)}</h1>
      </div>

      <div
        className="level-item is-green fadeInUp"
        style={{animationDelay: '1.2s'}}
      >
        <h5 className="heading">Recovered</h5>
        
         <h4>
         [
          {stats.deltarecovered == 0 ? "" 
            : stats.deltarecovered > 0
            ? '+' + stats.deltarecovered
            : '' + stats.deltarecovered}
          ]
          </h4>
        
        <h1 className="title has-text-success">
          {stats.recovered == 0 ? "N/A" :addCommas(stats.recovered)}{' '}
        </h1>
      </div>

      <div
        className="level-item is-gray fadeInUp"
        style={{animationDelay: '1.3s'}}
      >
        <h5 className="heading">Deceased</h5>
        <h4>
         [
          {
             stats.deltadeaths == 0 ? "" 
            : stats.deltadeaths >= 0
            ? '+' + stats.deltadeaths
            : '' + stats.deltadeaths }
          ]
          </h4>
        <h1 className="title has-text-grey">{stats.deaths == 0 ? "N/A" :addCommas(stats.deaths)}</h1>
      </div>
    </div>
  );
}

export default Level;
